import { call, put } from 'redux-saga/effects';
import { retriable } from '../retriable';

import { ERROR_MESSAGE } from '../../redux/modules/message/message-actions';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import {
    FETCH_STOCK_WAREHOUSE_FAILURE,
    FETCH_STOCK_WAREHOUSE_SUCCESS,
} from '../../redux/modules/stockWarehouse/stockWarehouse-actions';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch, getErrorMessage, isValidFunction,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import MESSAGES from '../../constants/messages';
import { isObjectValidAndNotEmpty } from '../../constants/nullCheckUtils';
import { getStringFromObject } from '../../constants/lodashUtils';
import { PAGE, SIZE } from '../../constants/constants';

export const FETCH_STOCK_WAREHOUSE = '@@stockWarehouse/FETCH_STOCK_WAREHOUSE';

// eslint-disable-next-line import/prefer-default-export
export function* fetchPagesOfStockWarehouseWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const params = {
            page: getStringFromObject('page', action, PAGE),
            size: getStringFromObject('size', action, SIZE),
        };
        const filters = getStringFromObject('filters', action);
        if (isObjectValidAndNotEmpty(filters)) {
            const searchText = getStringFromObject('searchText', filters, '');
            const searchTextTrimed = searchText.trim();
            params.filter = { name: searchTextTrimed };
        }
        const response = yield call(retriable().get, action.api, {
            params,
        });
        yield put({
            type: FETCH_STOCK_WAREHOUSE_SUCCESS,
            data: response.data,
            filters: action.filters,
        });
        if (isValidFunction(action.successCallback)) {
            action.successCallback(response.data);
        }
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        if (isValidFunction(action.failureCallBack)) {
            action.failureCallBack();
        }
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: `${MESSAGES.STOCK_WAREHOUSE.FETCH_FAILED}: ${getErrorMessage(e)}`,
            });
        }
        yield put({ type: FETCH_STOCK_WAREHOUSE_FAILURE });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}
